(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-showcase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var DRAG_THRESHOLD = 4; // px of movement before a click counts as a drag
    var PAUSE_AFTER_INPUT = 1200; // ms the marquee waits after the user moves the track
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function initCarousel(root) {
      var track = root.querySelector('.cat-showcase__items');
      if (!track || track.dataset.catCarouselReady) return;
      track.dataset.catCarouselReady = '1';

      var prev = root.querySelector('[data-dir="prev"]');
      var next = root.querySelector('[data-dir="next"]');
      var looping = root.classList.contains('cat-showcase--loop');
      var speed = parseFloat(root.dataset.autoscrollSpeed) || 0; // px per second
      var originals = Array.prototype.slice.call(track.children);
      if (!originals.length) return;

      var setWidth = 0; // width of one full copy of the item set
      var pos = 0; // our authoritative scroll position
      var applied = -1; // last value we wrote to scrollLeft, to detect outside scrolling
      var pausedUntil = 0;
      var hovering = false;
      var dragging = false;
      var suppressClick = false;
      var dragStartX = 0;
      var dragStartPos = 0;
      var dragMoved = 0;
      var tween = null;
      var last = 0;

      /* ---- Cloning: enough copies to cover 2 viewports past the originals ---- */

      function makeClone(node) {
        var clone = node.cloneNode(true);
        clone.dataset.catClone = '1';
        clone.classList.remove('is-active');
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('a').forEach(function (link) {
          link.tabIndex = -1;
          link.removeAttribute('aria-current');
        });
        return clone;
      }

      function build() {
        track.querySelectorAll('[data-cat-clone]').forEach(function (node) {
          node.remove();
        });

        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        var first = originals[0];
        var lastItem = originals[originals.length - 1];
        setWidth = lastItem.offsetLeft + lastItem.offsetWidth - first.offsetLeft + gap;
        if (!(setWidth > 0)) return;

        var copies = Math.max(1, Math.ceil((track.clientWidth * 2) / setWidth));
        var frag = document.createDocumentFragment();
        for (var i = 0; i < copies; i++) {
          originals.forEach(function (node) {
            frag.appendChild(makeClone(node));
          });
        }
        track.appendChild(frag);
      }

      function wrap() {
        if (!looping || !(setWidth > 0)) {
          var max = Math.max(0, track.scrollWidth - track.clientWidth);
          pos = Math.min(Math.max(pos, 0), max);
          return;
        }
        pos = ((pos % setWidth) + setWidth) % setWidth;
      }

      /* ---- Arrows: eased tween so they don't fight the marquee ---- */

      function step(dir) {
        var now = performance.now();
        tween = { from: pos, delta: track.clientWidth * 0.85 * dir, start: now, dur: 450 };
        pausedUntil = now + 1500;
      }

      function updateArrows() {
        if (looping || !prev || !next) return; // an infinite track never hits an end
        var max = track.scrollWidth - track.clientWidth - 1;
        prev.disabled = track.scrollLeft <= 0;
        next.disabled = track.scrollLeft >= max;
      }

      /* ---- Frame loop ---- */

      function frame(now) {
        // The theme editor re-renders the section on every setting change, which
        // detaches this track. Ending the loop here stops it leaking one run per edit.
        if (!track.isConnected) return;

        var dt = last ? Math.min(now - last, 100) : 0;
        last = now;

        // Adopt any scrolling we did not cause (touch swipe, wheel, keyboard).
        var actual = track.scrollLeft;
        if (applied >= 0 && Math.abs(actual - applied) > 2) {
          pos = actual;
          tween = null;
          pausedUntil = now + PAUSE_AFTER_INPUT;
        }

        var drives = dragging;
        if (tween) {
          var t = Math.min(1, (now - tween.start) / tween.dur);
          var eased = 1 - Math.pow(1 - t, 3);
          pos = tween.from + tween.delta * eased;
          if (t >= 1) tween = null;
          drives = true;
        } else if (looping && speed > 0 && !hovering && !dragging && now >= pausedUntil && !reduceMotion.matches) {
          pos += (speed * dt) / 1000;
          drives = true;
        }

        if (drives) {
          wrap();
          track.scrollLeft = pos;
          applied = track.scrollLeft; // read back the value the browser actually rounded to
        } else {
          // Nothing of ours is moving the track: stay out of the browser's way
          // so native momentum and snap animations finish untouched.
          pos = actual;
          applied = actual;
        }

        requestAnimationFrame(frame);
      }

      /* ---- Pointer drag (mouse); touch keeps native momentum scrolling ---- */

      track.addEventListener('pointerdown', function (event) {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        dragging = true;
        dragMoved = 0;
        suppressClick = false;
        dragStartX = event.clientX;
        dragStartPos = pos;
        tween = null;
        // Deliberately no setPointerCapture here: capturing retargets the click
        // to the track, which would stop card links from ever opening.
      });

      track.addEventListener('pointermove', function (event) {
        if (!dragging) return;
        var dx = event.clientX - dragStartX;
        dragMoved = Math.max(dragMoved, Math.abs(dx));
        if (dragMoved > DRAG_THRESHOLD) {
          // Now that this is a real drag, capture so the pan keeps tracking the
          // pointer outside the track. The retargeted click is unwanted anyway.
          if (!track.hasPointerCapture(event.pointerId)) {
            track.setPointerCapture(event.pointerId);
          }
          root.classList.add('is-dragging');
          event.preventDefault();
        }
        pos = dragStartPos - dx;
      });

      function endDrag(event) {
        if (!dragging) return;
        dragging = false;
        root.classList.remove('is-dragging');
        pausedUntil = performance.now() + PAUSE_AFTER_INPUT;
        if (dragMoved > DRAG_THRESHOLD) suppressClick = true;
        if (event && event.pointerId != null && track.hasPointerCapture(event.pointerId)) {
          track.releasePointerCapture(event.pointerId);
        }
      }

      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);

      // Swallow the click that ends a drag so the card link is not followed.
      track.addEventListener(
        'click',
        function (event) {
          if (!suppressClick) return;
          suppressClick = false;
          event.preventDefault();
          event.stopPropagation();
        },
        true
      );

      track.addEventListener('dragstart', function (event) {
        event.preventDefault();
      });

      /* ---- Pause triggers ---- */

      track.addEventListener('pointerenter', function () {
        hovering = true;
      });
      track.addEventListener('pointerleave', function () {
        hovering = false;
      });
      track.addEventListener('focusin', function () {
        hovering = true;
      });
      track.addEventListener('focusout', function () {
        hovering = false;
      });

      if (prev)
        prev.addEventListener('click', function () {
          step(-1);
        });
      if (next)
        next.addEventListener('click', function () {
          step(1);
        });

      if (looping) {
        build();
        wrap();
        requestAnimationFrame(frame);
      } else {
        track.addEventListener('scroll', updateArrows, { passive: true });
        requestAnimationFrame(frame); // still drives arrow tweens and mouse drag
        updateArrows();
      }

      var resizeTimer = null;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          if (looping) {
            build();
            wrap();
          }
          updateArrows();
        }, 150);
      });
    }

    document.querySelectorAll('.cat-showcase').forEach(initCarousel);

    // Theme editor re-renders the section without a page load.
    document.addEventListener('shopify:section:load', function (event) {
      event.target.querySelectorAll('.cat-showcase').forEach(initCarousel);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
(function () {
  // video-media binds its play handler on itself, and the play button sits outside it as a
  // sibling, so the button has no behaviour of its own. When a link overlay covers the media
  // the button is the only remaining way in, and its clicks have to be forwarded by hand.
  document.addEventListener('click', function (event) {
    var button = event.target.closest('.play-button');
    if (!button) return;

    var container = button.closest('.content-over-media');
    if (!container || !container.querySelector('.video-link')) return;

    var medias = Array.prototype.slice.call(container.querySelectorAll('video-media:not([autoplay])'));
    // Mobile and desktop variants both sit in the DOM; only the displayed one should play.
    var visible = medias.filter(function (media) {
      return media.offsetParent !== null;
    });
    var target = visible[0] || medias[0];
    if (target) target.click();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
